'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactInstantsearchCore = require('react-instantsearch-core');

var Index = (0, _reactInstantsearchCore.createIndex)({
  Root: 'div',
  props: {
    className: 'ais-MultiIndex__root'
  }
});

exports.default = Index;


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch-dom/dist/cjs/widgets/Index.js
// module id = 1009
// module chunks = 142807904292071